import request from '@/utils/request';
//common.js
import {getLocalStorage,setLocalStorage} from '@/utils/common';


let server = {
  placeOrder: '/orders', // 提交订单
  payOrder: '/orders/pay/', // 订单支付
  getHipopayQR:'/orders/getHipopayQR',//获取hipopay二维码
  orderPayQuery:'/orders/orderPayQuery',//获取订单支付状态
  orderList: '/orders?include=goods', // 订单列表
  updateOrder: '/orders', // 更新订单
  orderPage: '/orders?page=', // 订单分页
  deliveryBills: '/orders', // 订单发货单列表
  notify: '/orders/notify', // 订单支付回调
  checkPay: '/check_pay_password', // 交易密码验证
  tracking: '/delivery_bills', // 交易密码验证
};



//  提交订单
export function placeOrder(params) {
	return request({
    	url: server.placeOrder,
	    method: 'post',
	    data:params
  	})
}

//  订单详情
export function orderMsg(order) {
	return request({
    	url: server.placeOrder + '/' + order + '?include=goods',
	    method: 'get'
  	})
}


//  订单支付
export function payOrder(params , order) {
	return request({
    	url: server.payOrder + order,
	    method: 'post',
	    data:params
  	})
}

//  获取hipopay二维码
export function getHipopayQR(order,payment_method) {
    return request({
        url: server.getHipopayQR+'/'+order+'/'+payment_method,
        method: 'get',
    })
}

//  获取hipopay二维码
export function orderPayQuery(order) {
    return request({
        url: server.orderPayQuery+'/'+order,
        method: 'get',
    })
}


//  订单列表
export function orderList(params,page) {
	return request({
    	url: server.orderList ,
	    method: 'get',
      params
  	})
}


//  更新订单
export function updateOrder(params , orderId) {
	return request({
    	url: server.updateOrder + '/' + orderId,
	    method: 'patch',
      params
  	})
}



//  分页
export function orderPage(page) {
	return request({
    	url: server.orderPage + page + '&include=goods',
	    method: 'get',
  	})
}



//  发货单物流
export function deliveryBills(params) {
	return request({
    	url: server.deliveryBills + '/' + params + '/delivery_bills',
	    method: 'get',
  	})
}


//  发货单物流
export function tracking(params) {
	return request({
    	url: server.tracking + '/' + params + '/tracking',
	    method: 'get',
  	})
}


//  订单支付回调
export function notify(params) {
	return request({
    	url: server.notify ,
	    method: 'post',
      data:params
  	})
}

//  订单支付回调
export function checkPay(params) {
	return request({
    	url: server.checkPay ,
	    method: 'post',
      data:params
  	})
}

































// WEBPACK FOOTER //
// ./src/api/order.js